var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 9.5C9.95848 9.5 10.8954 9.22142 11.6924 8.69948C12.4893 8.17755 13.1105 7.4357 13.4773 6.56775C13.8441 5.6998 13.94 4.74473 13.753 3.82332C13.566 2.90191 13.1045 2.05554 12.4267 1.39124C11.749 0.726945 10.8855 0.274552 9.94544 0.091272C9.00538 -0.0920077 8.03098 0.0020581 7.14546 0.361574C6.25994 0.72109 5.50307 1.32991 4.97057 2.11104C4.43807 2.89218 4.15385 3.81054 4.15385 4.75C4.15385 6.00978 4.66442 7.21796 5.57325 8.10876C6.48208 8.99956 7.71472 9.5 9 9.5ZM9 10.8571C5.99625 10.8571 0 12.6757 0 16.2857V19H18V16.2857C18 12.6757 12.0038 10.8571 9 10.8571Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.293e87830ba32fa4f20bad539d714169.svg";
export { ForwardRef as ReactComponent };